const SESSION_KEY = "openktv_session"

export const generateEphemeralUsername = () => {
  const alphabet = "abcdefghijklmnopqrstuvwxyz0123456789"
  const bytes = new Uint8Array(6)
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes)
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256)
    }
  }
  const suffix = Array.from(bytes, (byte) => alphabet[byte % alphabet.length]).join("")
  return `guest_${suffix}`
}

export const getSession = () => {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const setSession = (session) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  return session
}

export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY)
}

export const hasRole = (role) => getSession()?.role === role
